import { shipmentApiClient } from '../shipmentApiClient'
import { updateShipmentVisitOrderEndpoint } from './endpoint'
import type { UpdateShipmentVisitOrderParams, UpdateShipmentVisitOrderRequest } from './type'

export const updateShipmentVisitOrder = async (
  params: UpdateShipmentVisitOrderParams
): Promise<void> => {
  const body: UpdateShipmentVisitOrderRequest = {
    delivery_report_uid: params.deliveryReportUid,
    driver_phone: params.driverPhone,
    sequence_order: params.sequenceOrder,
  }
  await shipmentApiClient.post(
    updateShipmentVisitOrderEndpoint(params.shipmentUid, params.visitId),
    body
  )
}
